/*eslint-disable */
import {
  mapGetters
} from 'vuex'; 
const $ = window.jQuery = require('jquery'); 
import axios from 'axios'; 
import toast from '../../../services/toast';
import countries from '../../../services/country.json'
export default {
  name: 'all-user-list',
  components: {},
  props: [],
  data () {
    return {
      memberAllUser:{},
      memberAllUserResults:[],
      nextStep:'',
      loadmoreData: {},
      userLoading: false,
      submitted:false,
      countryList:[],
      removeUserFromOurList:false,
      removeUserId:'',
      getDeactivatedUserListDetails:{},
      getDeactivatedUserList:[],
      deactivatedloadmoreData: {},
      deactivatedNextStep:'',
      nextPageUrl:'',
      deactivatedPageUrl:'',
      signUpedUserList:'',
      signUpedUserResults:[],
      signupedUserApproved:false,
      signupedUserDeclined:false,
      signupedUserApprovedId:'',
      signupedUserDeclinedId:''
    }
  },
  computed: {
  ...mapGetters([
    'getAllUserListGetters',
    'acUserDetailsStateGetters',
    'getDeactivatedAllUserListGetters',
    'signUpedUsersListGetters'
  ]),
  getmemberAllUserDetailsFun(){
   this.memberAllUser = this.$store.getters.getAllUserListGetters.data
   return 
  },
  SetIntialStatus() {
    if (this.memberAllUser != undefined) {
      this.nextStep = this.memberAllUser.next
      this.nextPageUrl = this.memberAllUser.next
      this.memberAllUserResults = this.memberAllUser.results
    }
  },
  getDeactivatedUserListFun(){
    this.getDeactivatedUserListDetails = this.$store.getters.getDeactivatedAllUserListGetters.data
    return
  },
  setIntialDeactivatedUserList(){
    if(this.getDeactivatedUserListDetails != undefined){
      this.deactivatedNextStep = this.getDeactivatedUserListDetails.next
      this.deactivatedPageUrl = this.getDeactivatedUserListDetails.next
      this.getDeactivatedUserList = this.getDeactivatedUserListDetails.results
    }
  }, 
  signUpedUsersListFun(){
    this.signUpedUserList = this.$store.getters.signUpedUsersListGetters.data
    return
  },
  setIntialSignUpedUserList(){
    if(this.signUpedUserList != undefined){
      this.signUpedUserResults = this.signUpedUserList.results
    }
  }
  },
  mounted () {
    Object.keys(countries).map((key, index) => {
      this.countryList.push({
        name: countries[key].toLowerCase(),
        value: key.toLowerCase()
      })
    });
    this.countryList.sort((a, b) => (a.name > b.name) ? 1 : -1)
    this.getmemberAllUserDetailsFun
    this.SetIntialStatus 
    this.getDeactivatedUserListFun
    this.setIntialDeactivatedUserList
    this.signUpedUsersListFun
    this.setIntialSignUpedUserList
  },
  methods: {
    approvedUserConfirmation(id){
      this.signupedUserApprovedId = id
      this.signupedUserApproved = true
      $("body").addClass("notConnectedUserBody");
    },
    declinedUserConfirmation(id){
      this.signupedUserDeclinedId = id
      this.signupedUserDeclined = true
      $("body").addClass("notConnectedUserBody");
    },
    approvedModalItemConfirmFun(){
      let data = {
        is_active:true,
        accepted:true
      }
      this.$store.dispatch('updateOrgUseDetailsByIdFun', {data: {data: data,id: this.signupedUserApprovedId}})
        .then((res) => {
            toast.success(res.data.msg);
            this.getSignupedUserListAgainFun()
            this.getActiveUserListAgainFun()
            this.closeApprovedItemModalFun()
        }).catch((err) => {
          toast.error(err.data.data.email);
        })
    },
    closeApprovedItemModalFun(){
      this.signupedUserApproved = false
      $("body").removeClass("notConnectedUserBody");
    },
    declinedModalItemConfirmFun(){
      let data = {
        is_deleted:true
      }
      this.$store.dispatch('updateOrgUseDetailsByIdFun', {data: {data: data, id: this.signupedUserDeclinedId}})
        .then((res) => {
            toast.success(res.data.msg);
            this.getSignupedUserListAgainFun()
            this.closeDeclinedItemModalFun()
        }).catch((err) => {
          toast.error(err.data.data.email);
        })
    },
    closeDeclinedItemModalFun(){
      this.signupedUserDeclined = false
      $("body").removeClass("notConnectedUserBody");
    },
    getSignupedUserListAgainFun(){
      this.$store.dispatch('getListOfSignupedUserFun').then((res) => {
        this.signUpedUserList = res.data.data
      }).catch((err) => {
      })
    },
    getActiveUserListAgainFun(){
      this.$store.dispatch('getAllUserListsFun').then((res) => {
        this.memberAllUser = res.data.data
      }).catch((err) => {
      })
    },
    getRemoveListAgain() {
      this.$store.dispatch('getAllUserListsFun').then((res) => {
        this.memberAllUser = res.data.data
      }).catch((err) => {
      })
      this.$store.dispatch('getDeactivatedAllUserListsFun').then((res) => {
        this.getDeactivatedUserListDetails = res.data.data
      }).catch((err) => {
      })
    },
    showRemovedModalFun(id){
      $("body").addClass("notConnectedUserBody");
      this.removeUserFromOurList = true
      this.removeUserId = id
    },
    removeModalItemConfirmFun(){
      this.$store.dispatch('removeSaOrgUserFun', {
        id: this.removeUserId,
      })
      .then((res) => {
        if (res.status == '200') {      
          toast.success(res.data.msg); 
          $("body").removeClass("notConnectedUserBody");
          this.removeUserFromOurList = false
          this.removeUserId = ''
          this.getRemoveListAgain()
        }
      }).catch((err) => {
        toast.error(err.data.user_msg);  
      })
    return;
    },
    closeRemoveItemModalFun(){
      $("body").removeClass("notConnectedUserBody");
      this.removeUserFromOurList = false
      this.taskDeleteId = ''
    },
    showLoadMoreDeactivateDataFun(url) {
      this.userLoading = true
      axios.get(url).then((response) => {
          this.deactivatedloadmoreData = response.data
          this.deactivatedNextStep = this.deactivatedloadmoreData.data.next
          this.$set(this.memberAllUserResults, 'next', this.deactivatedNextStep)
          if (this.deactivatedloadmoreData != undefined) {
            for (var i = 0; i < this.deactivatedloadmoreData.data.results.length; i++) {
              this.memberAllUserResults.push(this.deactivatedloadmoreData.data.results[i]);
              this.userLoading = false
            }
          }
        });
    },
    showLoadMoreDataFun(url) {
      this.userLoading = true
      axios.get(url).then((response) => {
          this.loadmoreData = response.data
          this.nextStep = this.loadmoreData.data.next
          this.$set(this.memberAllUserResults, 'next', this.nextStep)
          if (this.loadmoreData != undefined) {
            for (var i = 0; i < this.loadmoreData.data.results.length; i++) {
              this.memberAllUserResults.push(this.loadmoreData.data.results[i]);
              this.userLoading = false
            }
          }
        });
    },
    getCountryFlag: function(countryCode, type) {
      if (countryCode == null) {
        countryCode = ''
      }
      let countryName = countryCode.toLowerCase()
      let country = this.countryList.filter(item => (item.value) == (countryName) || (item.name) == (countryName));
      if (country && country.length > 0) {
        country = country[0]
        if (type == 'flag') {
          country = `https://www.countryflags.io/${country.value}/shiny/64.png`
        } else {
          country = country.name
        }
      } else {
        country = ''
      }
      return country;
    },
  },
  watch:{
    nextStep(old_val, new_val){
      if(new_val != ''){
        this.nextPageUrl = new_val
      }
    },
    deactivatedNextStep(old_val){
      if(old_val != ''){
        this.deactivatedPageUrl = old_val
      }
    },
    getmemberAllUserDetailsFun(){
      return  this.$store.getters.getAllUserListGetters.data
    },
    SetIntialStatus() {
      if (this.memberAllUser != undefined) {
        this.memberAllUserResults = this.memberAllUser.results
      }
    },
    getDeactivatedUserListFun(){
      return this.$store.getters.getDeactivatedAllUserListGetters
    },
    setIntialDeactivatedUserList(){
      if(this.getDeactivatedUserListDetails != undefined){
        this.getDeactivatedUserList = this.getDeactivatedUserListDetails.results
      }
    },
    signUpedUsersListFun(){
      this.signUpedUserList = this.$store.getters.signUpedUsersListGetters.data
      return
    },
    setIntialSignUpedUserList(){
      if(this.signUpedUserList != undefined){
        this.signUpedUserResults = this.signUpedUserList.results
      }
    }
  },
  beforeCreate: function() {
    // $('body').addClass('sidebar_collapsed')
  },
  beforeRouteLeave: function(to, from, next) {
    // $('body').removeClass('sidebar_collapsed')
      $("body").removeClass("notConnectedUserBody");
    next();
  },
}